/** CP-060 UX V2 — scenario-first correction workspace (nested under correction workspace flag). */
export function isRouteCorrectionUxV2Enabled(): boolean {
  return String(process.env.REACT_APP_ROUTE_CORRECTION_UX_V2 || 'true').toLowerCase() !== 'false';
}
